// extracted by mini-css-extract-plugin
export var content = "_mw-1";
export var fullScreen = "_mw-0";